import React from 'react'
import { Link } from 'react-router-dom'

function Cta({ cta, primary }) {
  if (!cta) return null
  // Buttons now live in a light section below the hero, so the secondary is styled for a white bg.
  const classes = primary
    ? 'inline-flex items-center justify-center rounded-xl bg-gradient-to-r from-emerald-500 to-teal-500 px-6 py-3 font-bold text-white shadow-lg transition hover:from-emerald-400 hover:to-teal-400'
    : 'inline-flex items-center justify-center rounded-xl border border-emerald-200 bg-emerald-50 px-6 py-3 font-semibold text-emerald-700 transition hover:bg-emerald-100'
  return cta.to.startsWith('/') ? <Link to={cta.to} className={classes}>{cta.label}</Link> : <a href={cta.to} className={classes}>{cta.label}</a>
}

// PageHero — the one hero pattern for every attorney page.
// Standard height, scrim-free image; only the eyebrow + title sit over the photo.
// Body copy and CTAs always render in a section directly below the image, never over it.
export function PageHero({ eyebrow, title, body, image, imageAlt, primaryCta, secondaryCta, imagePosition = 'center', center = false, belowTint = false, contentTop = false }) {
  return (
    <>
      <section className={`relative isolate flex min-h-[560px] flex-col overflow-hidden bg-slate-950 text-white sm:min-h-[680px] ${contentTop ? 'justify-start' : 'justify-end'}`}>
        <img src={image} alt={imageAlt} style={{ objectPosition: imagePosition }} className="absolute inset-0 -z-20 h-full w-full object-cover" loading="eager" />
        <div className={`mx-auto w-full max-w-7xl px-5 ${contentTop ? 'pt-16 sm:pt-20' : 'pb-16 sm:pb-20'}`}>
          <div className={`max-w-3xl ${center ? 'lg:ml-[10%]' : ''}`}>
            <p className="lc-rise text-sm font-extrabold uppercase tracking-[0.22em] text-emerald-400 sm:text-base">{eyebrow}</p>
            <h1 className="lc-rise mt-5 text-4xl font-bold leading-tight tracking-tight text-white [text-shadow:0_2px_12px_rgba(0,0,0,0.55)] sm:text-5xl lg:text-6xl" style={{ animationDelay: '.08s' }}>{title}</h1>
            <div className="mt-6 h-1 w-20 rounded bg-gradient-to-r from-emerald-400 to-teal-400" />
          </div>
        </div>
      </section>
      {(body || primaryCta || secondaryCta) && (
        <section className={`py-16 sm:py-20 ${belowTint ? 'border-y border-emerald-100 bg-emerald-50' : 'bg-white'}`}>
          <div className="mx-auto max-w-3xl px-5 text-center">
            {body && <div className="text-lg leading-relaxed text-slate-600">{body}</div>}
            {(primaryCta || secondaryCta) && (
              <div className="mt-8 flex flex-wrap justify-center gap-4">
                <Cta cta={primaryCta} primary />
                <Cta cta={secondaryCta} />
              </div>
            )}
          </div>
        </section>
      )}
    </>
  )
}
